// lista de investimentos.
export const GET_INVESTMENT = "GET_INVESTMENT";

// lista de configurações de parâmetros.
export const GET_PARAMETER_SETTINGS = "GET_PARAMETER_SETTINGS";
export const INIT_TOPIC = "INIT_TOPIC";
export const ADD_TOPIC = "ADD_TOPIC";
export const STOP_TOPIC = "STOP_TOPIC";
export const SEND_MESSAGE = "SEND_MESSAGE";

// atualizar investimento de acordo com o tópico.
export const UPDATE_BY_INVESTMENT_ID = "UPDATE_BY_INVESTMENT_ID";

export const UPDATE_BY_MARKETDATA = "UPDATE_BY_MARKETDATA";

// atualiza o investimento ao receber evento de snapshot
export const UPDATE_BY_INVESTMENT_ID_SNAPSHOT_EVENT =
  "UPDATE_BY_INVESTMENT_ID_SNAPSHOT_EVENT";

// fecha a posição e limpa o card do investimento
export const CLEAN_INVESTMENT_BY_INVESTMENT_ID =
  "CLEAN_INVESTMENT_BY_INVESTMENT_ID";

// atualiza o preço médio, stop loss e gain.
export const UPDATE_BY_INVESTMENT_ID_UPDATE_POSITION_EVENT =
  "UPDATE_BY_INVESTMENT_ID_UPDATE_POSITION_EVENT";

// investimento atingiu a meta de ganho
export const UPDATE_STRATEGY_GAIN = "UPDATE_STRATEGY_GAIN";

// investimento atingiu o limite de perda
export const UPDATE_STRATEGY_LOSS = "UPDATE_STRATEGY_LOSS";

// quando o investimento para de operar
export const UPDATE_STRATEGY_TIME = "UPDATE_STRATEGY_TIME";

//----------------------------------------------------------------------------------------------
// EDITAR PARÂMETROS

// Lista com todos as opções (conjunto) de parâmetros
export const LIST_PARAMS = "LIST_PARAMS";

// Parâmetro selecionado
export const SELECTED_PARAM = "SELECTED_PARAM";

// Informações do parâmetro selecionado, incluindo as seções de parâmetros
export const GET_PARAM_INFO = "GET_PARAM_INFO";

// Guarda o índice da seção visível
export const SECTION_INDEX = "SECTION_INDEX";

export const SEARCH_INVESTMENT = "SEARCH_INVESTMENT";

export const ORDER_INVESTMENT = "ORDER_INVESTMENT";

export const FILTERS_INVESTMENT = "FILTERS_INVESTMENT";

export const REMOVER_FILTERS_INVESTMENT = "REMOVER_FILTERS_INVESTMENT";

export const SELECTED_PARAMS_INVESTMENT = "SELECTED_PARAMS_INVESTMENT";

export const UPDATE_INVESTMENT = "UPDATE_INVESTMENT";

export const SET_VISUALIZATION_MODE = "SET_VISUALIZATION_MODE";

export const SET_INVESTMENT_VOLUME = "SET_INVESTMENT_VOLUME";

export const SET_INVESTMENT_VOLUME_TYPE = "SET_INVESTMENT_VOLUME_TYPE";

export const SET_INVESTMENT_VOLUME_BY_TYPE = "SET_INVESTMENT_VOLUME_BY_TYPE";

export const SET_INVESTMENT_SYMBOL_PRICE = "SET_INVESTMENT_SYMBOL_PRICE";

export const SET_GAIN_LOSS = "SET_GAIN_LOSS";

export const SET_PARAM_BY_ID = "SET_PARAM_BY_ID";

export const SET_SAVE_IS_ENABLED = "SET_SAVE_IS_ENABLED";

export const SET_STRING_FILTER = "SET_STRING_FILTER";

export const SET_RANGE_FILTER = "SET_RANGE_FILTER";

export const SET_TOGGLE_FILTER = "SET_TOGGLE_FILTER";

export const SET_SEARCH_CHARS = "SET_SEARCH_CHARS";

export const INVESTMENT_CLEAR_ACTIVE_FILTERS =
  "INVESTMENT_CLEAR_ACTIVE_FILTERS";
